
define(
	'Eureka.MaxaTrendingProducts.TrendingProcuts'
	, [
		'Eureka.MaxaTrendingProducts.TrendingProcuts.View',
		'Eureka.MaxaTrendingProducts.AboutUs.View',
		'Eureka.MaxaTrendingProducts.OurTeam.View',
		'Eureka.MaxaTrendingProducts.Ezystor.View',
		'Eureka.MaxaTrendingProducts.Catalogues.View',
		'Eureka.MaxaTrendingProducts.PartsPicker.View',
		'Eureka.MaxaTrendingProducts.MaxaIreland.View',
		'Eureka.MaxaTrendingProducts.WheelSentry.View',
		'Eureka.MaxaTrendingProducts.SignUp.View',
		'Eureka.MaxaTrendingProducts.Welcome.View',
	]
	, function (
		TrendingProcutsView,
		AboutUsView,
		OurTeamView,
		EzystorView,
		CataloguesView,
		PartsPickerView,
		MaxaIrelandView,
		WheelSentryView,
		SignUpView,
		WelcomeView,
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				// using the 'Layout' component we add a new child view inside the 'Header' existing view 
				// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
				// more documentation of the Extensibility API in
				// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

				/** @type {LayoutComponent} */
				var layout = container.getComponent('Layout');

				if (layout) {
					layout.addChildView('MaxaTrendingProducts', function () {
						return new TrendingProcutsView({ container: container });
					});

				}
				var PageType = container.getComponent('PageType')

				PageType.registerPageType({
					name: 'MaxaAboutUs',
					routes: ['about-us'],
					view: AboutUsView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_aboutus.tpl',
						displayName: 'About Us'
					}
				})
				PageType.registerPageType({
					name: 'MaxaOurTeam',
					routes: ['about-us/our-team'],
					view: OurTeamView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_ourteam.tpl',
						displayName: 'Our Team'
					}
				})
				PageType.registerPageType({
					name: 'MaxaEzystor',
					routes: ['about-us/ezystor'],
					view: EzystorView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_ezystor.tpl',
						displayName: 'Ezystor'
					}
				})
				PageType.registerPageType({
					name: 'MaxaCatalogues',
					routes: ['catalogues'],
					view: CataloguesView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_catalogues.tpl',
						displayName: 'Catalogues'
					}
				})
				PageType.registerPageType({
					name: 'MaxaPP',
					routes: ['parts-picker'],
					view: PartsPickerView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_partspicker.tpl',
						displayName: 'Parts Picker'
					}
				})
				PageType.registerPageType({
					name: 'MaxaIreland',
					routes: ['maxa-ireland'],
					view: MaxaIrelandView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_maxa_ireland.tpl',
						displayName: 'Maxa Ireland'
					}
				})
				PageType.registerPageType({
					name: 'WheelSentry',
					routes: ['wheel-sentry'],
					view: WheelSentryView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_wheel_sentry.tpl',
						displayName: 'Wheel Sentry'
					}
				})
				PageType.registerPageType({
					name: 'MaxaSignUp',
					routes: ['sign-up'],
					view: SignUpView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_partspicker.tpl',
						displayName: 'Sign Up'
					}
				})
				PageType.registerPageType({
					name: 'MaxaWelcome',
					routes: ['welcome'],
					view: WelcomeView,
					defaultTemplate: {
						name: 'eureka_maxatrendingproducts_partspicker.tpl',
						displayName: 'Welcome'
					}
				})
			}
		};
	});
